import { inject, ref } from 'vue';
import INJECT_KEYS from '@/app/data/inject_keys';

class BreadCrumbs {
  crumbs = ref([]);

  add(arr) {
    this.crumbs.value = arr;
  }

  append(arr) {
    arr.forEach((crumb) => this.crumbs.value.push(crumb));
  }

  reset() {
    this.crumbs.value = [];
  }
}

// Create a composable for use in setup()
export function useBreadcrumbs() {
  return inject(INJECT_KEYS.BREADCRUMBS);
}

export default {
  install(app) {
    const breadcrumbsInstance = new BreadCrumbs();
    app.provide(INJECT_KEYS.BREADCRUMBS, breadcrumbsInstance);
  },
};
